import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import i18n from './i18n'
import './assets/css/main.css' // استيراد ملف الأنماط العام

import { pinia } from "./store/index";

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)

router.isReady().then(() => {
  app.mount('#app')
})

